import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function calcularEdad(fechaNacimiento: string | Date): number | string {
  const hoy = new Date()
  const nacimiento = new Date(fechaNacimiento)

  let edad = hoy.getFullYear() - nacimiento.getFullYear()
  const mes = hoy.getMonth() - nacimiento.getMonth()

  if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
    edad--
  }

  return isNaN(edad) ? "--" : edad
}

export const toSlug = (input: string): string => {
  return input
    .normalize("NFD") // descompone caracteres con tildes (á -> a + ́)
    .replace(/[\u0300-\u036f]/g, "") // elimina los diacríticos
    .replace(/[^a-zA-Z0-9]/g, "-") // reemplaza todo lo que no sea alfanumérico por guiones
    .replace(/-+/g, "-") // colapsa múltiples guiones en uno
    .replace(/^-|-$/g, "") // elimina guiones al inicio o fin
    .toLowerCase()
}
